<!-- 选择带队人员信息 -->
<template>
  <a-spin :spinning="dataLoading">
    <div class="titleDiv">
      <div></div>
      <p>{{$t('选择带队成员')}}</p>
    </div>
    <a-tabs :default-active-key="defaultTab" type="card" style="margin-bottom:20px;" v-for="(item, index) in leaders" :key="index">
      <a-tab-pane :tab="$t(getTabName(item))" >
        <div
          :style="{
            minHeight: '200px',
            overflow: 'hidden',
            position: 'relative',
            border: '1px solid #ebedf0',
            background: '#fff'}">
          <div class="leaderData">
            <span v-if="coachData[item.code] && coachData[item.code].length > 0">
              <div class="leader" v-for="(coach, index1) in coachData[item.code]" :key="index1">
                <img class="coachHeader" :src="coach.image" @click="choiceCoach(coach.id)">
                <img class="coachHeader checked" src="@comm/assets/join/imgCheck.png" v-if="choiceCoachIds.indexOf(coach.id) > -1" @click="choiceCoach(coach.id)">
                <p style="text-align: center;">{{ coach.name }}</p>
              </div>
            </span>
            <div class="leader">
              <img class="coachHeader" :src="addImg" @click="showDrawer(item)">
              <p style="text-align: center;">{{ $t('点击添加') }}{{ $t(item.name) }}</p>
            </div>
          </div>
          <a-drawer
            placement="left"
            :closable="false"
            :visible="item['visible'] == true"
            :width="400"
            :get-container="false"
            :wrap-style="{ position: 'absolute' }"
            @close="onClose(item)">
            <a-spin :spinning="item['loading'] || false">
              <div class="drawerLeaderContainer">
                <div class="imgContainer">
                  <Upload
                    ref="upload"
                    :length="1"
                    :imgs="imgs"
                    uploadTest="头像"
                    @uploadSuccess="uploadSuccess($event, index)"
                    :cutImg="true"
                    :fixedNumber="[5,7]"/>
                </div>
                <div>
                  <div>
                    <a-input placeholder="请输入名称" :maxLength="10" v-model="item['nickname']"/>
                  </div>
                  <div class="phoneDiv">
                    <a-input placeholder="请输入手机号码" :maxLength="11" v-model="item['phone']"/>
                  </div>
                  <div class="phoneDiv">
                    <a-input placeholder="请输入身份证号码" v-model="item['card']"/>
                  </div>
                  <div class="operContainer">
                    <a-button type="primary" @click="submit(item, index)"> 确定 </a-button>
                    <a-button class="cancel" @click="onClose(item)"> 取消 </a-button>
                    {{ item['logo'] }}
                  </div>
                </div>
              </div>
            </a-spin>
          </a-drawer>
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>
<script>
import Upload from '@comm/upload/Upload'
import store from '@/store'
export default {
  components: {
    Upload
  },
  data () {
    return {
      leaders: [],
      coachData: {},
      choiceCoachIds: [],
      matchInfo: store.getters['match/matchInfo'],
      defaultImg: require('@comm/assets/join/null.png'),
      visible: false,
      defaultTab: 0,
      addImg: require('@comm/assets/join/add_bg.jpg'),
      upImageIndex: 0,
      programId: this.$route.query.programId || 0,
      agencyId: this.$route.query.agencyId || null,
      matchId: this.$route.query.matchId || null,
      teamId: this.$route.query.teamId || null,
      dataLoading: false,
      uploadingImg: false, // 是否正在上传图片
      imgs: []
    }
  },
  watch: {
    $route () {
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.matchId = this.$route.query.matchId
      this.agencyId = this.$route.query.agencyId
      this.programId = this.$route.query.programId
      this.teamId = this.$route.query.teamId
      if (this.teamId === undefined) {
        this.choiceCoachIds = []
      }
      this.initLeaderTab()
      this.queryAgencyStaff()
      this.uploadingImg = false
    },
    getTabName (item) {
      let required = item.required
      if (required) {
        return '* ' + item.name + (item.num > 0 ? '（ 最多' + item.num + '个）' : '')
      } else {
        return item.name + (item.num > 0 ? '（ 最多' + item.num + '个）' : '')
      }
    },
    onClose (item) {
      item['visible'] = false
      this.uploadingImg = false
      item['img'] = null
      item['nickname'] = null
      item['phone'] = null
      this.imgs = []
      this.$forceUpdate()
    },
    showDrawer (item) {
      item['visible'] = true
      this.$forceUpdate()
    },
    submit (item, index) {
      let img = item['img']
      console.log(this.matchInfo.imageIsRequired.staff)
      if (!img && !this.matchInfo.imageIsRequired.staff) {
        img = 'https://static.daoba.com//838779651131.jpg'
      }
      if (!img) {
        this.$message.error('请上传头像')
        return
      }
      let nickname = item['nickname']
      if (!nickname) {
        this.$message.error('请输入名称')
        return
      }
      let mobile = item['phone']
      if (!mobile) {
        this.$message.error('请输入手机号码')
        return
      }
      let card = item['card']
      if (!card && (Number(this.programId) === 4 || Number(this.programId) === 5)) {
        this.$message.error('请输入身份证号')
        return
      }
      let param = {
        agencyId: this.agencyId,
        image: img,
        mobile: mobile,
        card: item['card'],
        name: nickname,
        type: item.code
      }
      item['loading'] = true
      this.$forceUpdate()
      this.$api.join.addStaff(param).then(res => {
        item['loading'] = false
        if (res.status === 0) {
          this.queryAgencyStaff()
          this.$message.success(res.msg)
          this.onClose(item)
        } else {
          this.$message.error(res.msg)
        }
        this.$forceUpdate()
      }).catch(err => {
        console.log('err', err)
        item['loading'] = false
        this.$message.error('网络忙，提交失败')
        this.$forceUpdate()
      })
    },
    uploadSuccess (fileList, index) {
      this.imgs = fileList
      if (fileList.length > 0) {
        this.leaders[index]['img'] = fileList[0].url
      } else {
        this.leaders[index]['img'] = null
      }
    },
    // 通过队伍查询该队伍的带队教练信息
    queryLeadersByTeam () {
      this.dataLoading = true
      this.$api.join.queryLeadersByTeam(this.matchId, this.teamId).then(res => {
        if (res.status === 0 && res.data) {
          this.choiceCoachIds = res.data.split(',').map(item => Number(item))
        } else {
          this.choiceCoachIds = []
        }
        this.$forceUpdate()
      }).catch(err => {
        this.$message.error('error', (err.msg || '请求返回错误'))
      }).finally(_ => {
        this.dataLoading = false
      })
    },
    // 通过项目队伍查询该队伍的带队教练信息
    queryLeadersByTeamBig () {
      this.dataLoading = true
      this.$api.join.queryLeadersByTeamBig(this.matchId, this.teamId, this.$route.query.combatDetailId).then(res => {
        if (res.status === 0 && res.data) {
          this.choiceCoachIds = res.data.split(',').map(item => Number(item))
        } else {
          this.choiceCoachIds = []
        }
        this.$forceUpdate()
      }).catch(err => {
        this.$message.error('error', (err.msg || '请求返回错误'))
      }).finally(_ => {
        this.dataLoading = false
      })
    },
    // 查询机构下的教练、领队等信息
    queryAgencyStaff () {
      if (this.agencyId === null || this.agencyId === undefined) {
        return
      }
      this.dataLoading = true
      this.$api.join.queryAgencyStaff(this.agencyId).then(res => {
        this.coachData = res.data
        if (this.teamId != null) {
          if (this.$route.query.combatDetailId !== undefined) {
            this.queryLeadersByTeamBig()
          } else {
            this.queryLeadersByTeam()
          }
        }
      }).catch(err => {
        console.log('err', err)
        this.$message.error('网络忙, 获取教练信息失败')
      }).finally(_ => {
        this.dataLoading = false
      })
    },
    initLeaderTab () {
      this.leaders = JSON.parse(this.matchInfo.staffData)
    },
    choiceCoach (id) {
      var index = this.choiceCoachIds.indexOf(id)
      if (index > -1) {
        this.choiceCoachIds.splice(index, 1)
      } else {
        this.choiceCoachIds.push(id)
      }
      this.$forceUpdate()
    },
    // 获取选择的教练信息
    getChoiceCoach () {
      let pass = true
      let content = ''
      let choiceIds = []
      for (let j = 0; j < this.leaders.length; j++) {
        let item = this.leaders[j]
        let required = item.required
        
        // 获取类型
        let code = item.code
        // 判断该类型的数据是否已经选择
        let leadersData = this.coachData[code]
        let hasChoice = false
        let objNum = {}
        for (let i = 0; i < leadersData.length; i++) {
          let leaderId = leadersData[i].id
          if (this.choiceCoachIds.indexOf(leaderId) > -1) {
            choiceIds.push(leaderId)
            hasChoice = true
            if (objNum[code]) {
              objNum[code]++
            } else {
              objNum[code] = 1
            }
          }
        }
        if (!required && item.num <= 0) {
          continue
        }
        console.log(objNum)
        if (item.num > 0 && objNum[code] > item.num) {
          content = item.name + '最多选择' + item.num + '个'
          pass = false
          break
        }
        if (!hasChoice && required) {
          content = '请点击头像选择，至少选择一个' + item.name
          pass = false
          break
        }
      }
      let result = {
        result: pass,
        content: content,
        leaderIds: choiceIds.join(',')
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .ant-tabs-bar {
    margin: 0px;
  }
  .titleDiv {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 10px;
    div {
      height: 25px;
      width: 5px;
      background-color: #b80000;
    }
    p {
      font-size: 19px;
      font-weight: bold;
      margin-bottom: 0px;
      margin-left: 10px;
    }
  }
  .leaderData {
    display: flex;
    padding: 30px;
    flex-wrap: wrap;
    .leader {
      height: 140px;
      width: 100px;
      margin: 0 30px 30px 0;
      overflow: hidden;
      position: relative;
      float: left;
    }
    .coachHeader {
      height: 120px;
      width: 100px;
      border-radius:5px;
    }
    .checked {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .drawerLeaderContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    .imgContainer {
      height: 120px;
      width: 100px;
      margin-right: 30px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .phoneDiv {
      margin-top:15px
    }
    .operContainer {
      display: flex;
      justify-content: flex-end;
      margin-top: 15px;
      .cancel {
        margin-left: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/staff/StaffList.vue